import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackOverseasReturnOrderList from '../entities/order-back-list'
import UpdateBackAbroadOrderStatu from '@/store/entities/back-order-update-statu'
import appconst from '@/lib/appconst';
interface BackOverseasReturnOrderState extends ListState<BackOverseasReturnOrderList> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

class BackAbroadOrderMutations extends ListMutations<BackOverseasReturnOrderList>{

}
class BackOverseasReturnbroadOrder extends ListModule<BackOverseasReturnOrderState, any, BackOverseasReturnOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackOverseasReturnOrderList>(),
        loading: false,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackOverseasReturnOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/AbroadReturn/GetReturnOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackOverseasReturnOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: BackOverseasReturnOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackOverseasReturnOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: BackOverseasReturnOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        }
    }
}

const backoverseasreturnorders = new BackOverseasReturnbroadOrder();
export default backoverseasreturnorders;